/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./xlz-manage.vue?vue&type=template&id=06564d08&scoped=true&"
import script from "./xlz-manage.vue?vue&type=script&lang=ts&"
export * from "./xlz-manage.vue?vue&type=script&lang=ts&"
import style0 from "./xlz-manage.vue?vue&type=style&index=0&id=06564d08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06564d08",
  null
  
)

export default component.exports